(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initAnnouncementBarSplide(root) {
    if (typeof Splide === 'undefined') return;
    if (root.dataset.splideInitialized === 'true') return;
    root.dataset.splideInitialized = 'true';

    var duration = parseFloat(root.dataset.duration) || 5;

    var sp = new Splide(root, {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: duration * 1000,
      speed: 600,
      arrows: false,
      pagination: false,
      drag: false
    }).mount();

    // Las flechas se enganchan A MANO y no con la opcion `arrows` de Splide:
    // asi no reciben su CSS -circulo gris, flecha propia- ni su transform,
    // que era lo que dejaba las dos apuntando para el mismo lado.
    var prev = root.querySelector('[data-ab-prev]');
    var next = root.querySelector('[data-ab-next]');
    var total = root.querySelectorAll('.splide__slide').length;
    if (total < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    } else {
      if (prev) prev.addEventListener('click', function () { sp.go('<'); });
      if (next) next.addEventListener('click', function () { sp.go('>'); });
    }
  }

  function initAllAnnouncementBarSplides() {
    document.querySelectorAll('[data-announcement-bar-splide]').forEach(initAnnouncementBarSplide);
  }

  window.addEventListener('load', initAllAnnouncementBarSplides);
  document.addEventListener('shopify:section:load', initAllAnnouncementBarSplides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cartDrawerLoaded) return;
    window.__cartDrawerLoaded = true;

    function getRoot() {
      return document.querySelector('[data-cart-drawer]');
    }

    function setOpen(open) {
      const root = getRoot();
      if (!root) return;
      const overlay = root.querySelector('[data-cart-drawer-overlay]');
      const panel = root.querySelector('[data-cart-drawer-panel]');

      if (open) {
        root.classList.remove('hidden');
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
          panel.classList.remove('translate-x-full');
          panel.classList.add('translate-x-0');
        });
        document.documentElement.classList.add('overflow-hidden');
      } else {
        overlay.classList.remove('opacity-100');
        overlay.classList.add('opacity-0');
        panel.classList.remove('translate-x-0');
        panel.classList.add('translate-x-full');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('overflow-hidden');
        window.setTimeout(() => {
          const current = getRoot();
          if (current && current.getAttribute('aria-hidden') === 'true') current.classList.add('hidden');
        }, 300);
      }
    }

    function setLoading(loading) {
      const root = getRoot();
      if (!root) return;
      const overlay = root.querySelector('[data-cart-drawer-loading]');
      if (!overlay) return;
      overlay.classList.toggle('hidden', !loading);
      overlay.classList.toggle('flex', loading);
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count <= 0;
      });
    }

    async function refresh(options) {
      const open = !options || options.open !== false;
      const root = getRoot();
      if (!root) return;

      const sectionId = root.dataset.sectionId;
      const wasOpen = root.getAttribute('aria-hidden') === 'false';

      try {
        const response = await fetch(window.location.pathname + '?sections=' + sectionId);
        const data = await response.json();
        const html = data[sectionId];
        if (!html) return;

        const newRoot = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
        if (!newRoot) return;

        if (wasOpen) {
          newRoot.classList.remove('hidden');
          newRoot.setAttribute('aria-hidden', 'false');
          const overlay = newRoot.querySelector('[data-cart-drawer-overlay]');
          const panel = newRoot.querySelector('[data-cart-drawer-panel]');
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
          panel.classList.remove('translate-x-full');
          panel.classList.add('translate-x-0');
        }

        root.replaceWith(newRoot);
        bindDrawerEvents(newRoot);
        updateHeaderCount(Number(newRoot.dataset.itemCount || 0));

        if (open && !wasOpen) setOpen(true);
      } catch (error) {
        /* network hiccup: server-rendered cart state is still correct on next full page load */
      }
    }

    async function changeLine(lineKey, quantity) {
      setLoading(true);
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity }),
        });
        await refresh({ open: true });
      } finally {
        setLoading(false);
      }
    }

    async function addVariant(variantId) {
      setLoading(true);
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        await refresh({ open: true });
      } finally {
        setLoading(false);
      }
    }

    function bindDrawerEvents(root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      root.querySelector('[data-cart-drawer-overlay]')?.addEventListener('click', () => setOpen(false));

      root.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => setOpen(false));
      });

      root.addEventListener('click', (event) => {
        const decreaseBtn = event.target.closest('[data-cart-line-decrease]');
        const increaseBtn = event.target.closest('[data-cart-line-increase]');
        const removeBtn = event.target.closest('[data-cart-line-remove]');
        const upsellBtn = event.target.closest('[data-cart-upsell-add]');

        if (decreaseBtn || increaseBtn) {
          const lineItem = event.target.closest('[data-cart-line-item]');
          const qtyEl = lineItem.querySelector('[data-cart-line-quantity]');
          const qty = Number(qtyEl.textContent) + (increaseBtn ? 1 : -1);
          changeLine((decreaseBtn || increaseBtn).dataset.lineKey, Math.max(0, qty));
        } else if (removeBtn) {
          changeLine(removeBtn.dataset.lineKey, 0);
        } else if (upsellBtn && !upsellBtn.disabled) {
          addVariant(upsellBtn.dataset.variantId);
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      const root = getRoot();
      if (event.key === 'Escape' && root && root.getAttribute('aria-hidden') === 'false') setOpen(false);
    });

    document.addEventListener('cart:open', () => setOpen(true));
    document.addEventListener('cart:refresh', (event) => refresh(event.detail));
    document.addEventListener('cart:added', () => refresh({ open: true }));

    window.CartDrawer = {
      open: () => setOpen(true),
      close: () => setOpen(false),
      refresh: refresh,
    };

    function bindCurrentDrawer() {
      const current = getRoot();
      if (current) bindDrawerEvents(current);
    }

    window.addEventListener('load', bindCurrentDrawer);
    document.addEventListener('shopify:section:load', bindCurrentDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category"] && !Shopify.designMode) return;
  try {
    
  function initCategorySwiper() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.category-swiper').forEach(function (element) {
      if (element.swiper) return;

      var swiperOptions = {
        // igualado a Trending. El escritorio sigue en 4 / 16, mas abajo.
        slidesPerView: 1.4,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        }
      };

      // Desktop stays exactly as before (plain, snap-based). Mobile only
      // gets the fast free-drag feel from product-recommendations.
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        swiperOptions.resistanceRatio = 0;
        swiperOptions.freeMode = {
          enabled: true,
          momentum: true,
          momentumBounce: false,
          sticky: false
        };
      }

      new Swiper(element, swiperOptions);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategorySwiper);
  } else {
    initCategorySwiper();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-sort-option]')) {
      event.target.form.requestSubmit();
    }
  });

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches('[data-collection-toolbar] details') || !details.open) return;

    details
      .closest('[data-collection-toolbar]')
      .querySelectorAll('details[open]')
      .forEach(function (other) {
        if (other !== details) other.open = false;
      });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initHeaderActionTriggers(root) {
    if (root.dataset.actionTriggersInitialized === 'true') return;
    root.dataset.actionTriggersInitialized = 'true';

    root.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    });

    root.querySelectorAll('[data-search-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('search:open'));
      });
    });
  }

  function setNavOpen(root, open) {
    const nav = root.querySelector('[data-site-nav]');
    const overlay = root.querySelector('[data-nav-overlay]');
    const trigger = root.querySelector('[data-nav-trigger]');
    if (!nav) return;

    if (open) {
      if (overlay) overlay.classList.remove('hidden');
      requestAnimationFrame(() => {
        if (overlay) {
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
        }
        nav.classList.remove('-translate-x-full');
        nav.classList.add('translate-x-0');
      });
      document.documentElement.classList.add('overflow-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    } else {
      if (overlay) {
        overlay.classList.remove('opacity-100');
        overlay.classList.add('opacity-0');
      }
      nav.classList.remove('translate-x-0');
      nav.classList.add('-translate-x-full');
      document.documentElement.classList.remove('overflow-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => {
        if (overlay && nav.classList.contains('-translate-x-full')) overlay.classList.add('hidden');
      }, 300);
    }
  }

  function isNavOpen(root) {
    const nav = root.querySelector('[data-site-nav]');
    return !!nav && !nav.classList.contains('-translate-x-full');
  }

  function initNavDrawer(root) {
    if (root.dataset.navDrawerInitialized === 'true') return;
    root.dataset.navDrawerInitialized = 'true';

    const trigger = root.querySelector('[data-nav-trigger]');
    trigger?.addEventListener('click', () => setNavOpen(root, !isNavOpen(root)));

    root.querySelectorAll('[data-nav-close]').forEach((button) => {
      button.addEventListener('click', () => setNavOpen(root, false));
    });

    root.querySelector('[data-nav-overlay]')?.addEventListener('click', () => setNavOpen(root, false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isNavOpen(root)) setNavOpen(root, false);
    });

    const desktopQuery = window.matchMedia('(min-width: 1024px)');
    desktopQuery.addEventListener('change', (event) => {
      if (event.matches) setNavOpen(root, false);
    });
  }

  function initAllHeaderActionTriggers() {
    document.querySelectorAll('[data-header-section]').forEach((root) => {
      initHeaderActionTriggers(root);
      initNavDrawer(root);
    });
  }

  window.addEventListener('load', initAllHeaderActionTriggers);
  document.addEventListener('shopify:section:load', initAllHeaderActionTriggers);

  /* Ajusta el menu al ancho disponible.

     El equipo pidio las letras mas grandes "pero sin que se rompa en dos
     lineas cuando switch espanol 13inch screen". Un tamano fijo no sirve: el
     menu en espanol mide 49.2em de texto contra 42.6em en ingles, y el ancho
     libre depende del monitor.

     Se prueba de 17px para abajo hasta que la lista entra. La lista esta en
     `nowrap`, asi que mientras no entra se desborda -no se parte-, y por eso
     alcanza con comparar scrollWidth contra el ancho del <nav>.

     Hay que recalcular cuando termina de cargar la tipografia: si se mide
     antes, se mide la fuente de reemplazo, que es mas angosta, y queda un
     tamano que despues no entra. */
  function ajustarMenuLipo() {
    var listas = document.querySelectorAll('[data-nav-fit]');
    var ancho = window.matchMedia('(min-width: 1024px)').matches;
    for (var i = 0; i < listas.length; i++) {
      var ul = listas[i];
      var nav = ul.parentElement;
      if (!ancho || !nav) {
        ul.style.removeProperty('--nav-fs');
        ul.style.removeProperty('--nav-gap');
        continue;
      }
      for (var fs = 17; fs >= 11; fs--) {
        ul.style.setProperty('--nav-fs', fs + 'px');
        ul.style.setProperty('--nav-gap', Math.max(9, Math.round(fs * 1.3)) + 'px');
        if (ul.scrollWidth <= nav.clientWidth) break;
      }
    }
  }

  var tiempoMenuLipo;
  function ajustarMenuLipoDiferido() {
    clearTimeout(tiempoMenuLipo);
    tiempoMenuLipo = setTimeout(ajustarMenuLipo, 80);
  }

  ajustarMenuLipo();
  window.addEventListener('resize', ajustarMenuLipoDiferido);
  window.addEventListener('load', ajustarMenuLipo);
  document.addEventListener('shopify:section:load', ajustarMenuLipo);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(ajustarMenuLipo);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function initProductRecommendationsSwiper() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.product-recommendations-swiper').forEach(function (element) {
      if (element.swiper) return;

      var swiperOptions = {
        slidesPerView: 1.4,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      };

      // Desktop stays exactly as before (plain, snap-based). Mobile only
      // gets the fast free-drag feel from the old reviews-gallery Swiper
      // setup, since Swiper can't toggle freeMode per breakpoint.
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        swiperOptions.resistanceRatio = 0;
        swiperOptions.freeMode = {
          enabled: true,
          momentum: true,
          momentumBounce: false,
          sticky: false
        };
      }

      new Swiper(element, swiperOptions);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRecommendationsSwiper);
  } else {
    initProductRecommendationsSwiper();
  }

  /*
  Show more pagination disabled for now — showing all 48 items on one page.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-show-more-link]');
    if (!link || link.hasAttribute('data-loading')) return;

    var container = link.closest('[data-show-more]');
    var sectionId = container ? container.getAttribute('data-show-more') : null;
    var grid = sectionId ? document.querySelector('[data-product-grid="' + sectionId + '"]') : null;
    if (!container || !grid) return;

    event.preventDefault();
    link.setAttribute('data-loading', '');

    fetch(link.href)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid="' + sectionId + '"]');

        if (newGrid) {
          Array.from(newGrid.children).forEach(function (child) {
            grid.appendChild(document.importNode(child, true));
          });
        }

        var newShowMore = doc.querySelector('[data-show-more="' + sectionId + '"]');
        if (newShowMore) {
          container.replaceWith(document.importNode(newShowMore, true));
        } else {
          container.remove();
        }
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function initProductSection(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dataScript = root.querySelector('[data-product-json]');
    const productData = dataScript ? JSON.parse(dataScript.textContent) : { variants: [] };

    const swiperEl = root.querySelector('.product-gallery-swiper');
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));

    let gallerySwiper = null;
    let applyGalleryColor = null;

    if (swiperEl && typeof Swiper !== 'undefined') {
      let visibleThumbs = thumbs.slice();
      const setActiveThumb = (realIndex) => {
        visibleThumbs.forEach((thumb, index) => thumb.classList.toggle('outline-2', index === realIndex));
      };

      const galleryVideos = Array.from(swiperEl.querySelectorAll('.gallery-video'));
      let galleryInView = false;

      const pauseGalleryVideos = () => {
        galleryVideos.forEach((video) => video.pause());
      };

      galleryVideos.forEach((video) => {
        video.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        const muteButton = video.parentElement?.querySelector('.gallery-video-mute');
        const muteIconOn = muteButton?.querySelector('.gallery-video-mute-icon-on');
        const muteIconOff = muteButton?.querySelector('.gallery-video-mute-icon-off');

        if (muteButton) {
          const syncMuteState = () => {
            muteIconOn?.classList.toggle('hidden', video.muted);
            muteIconOff?.classList.toggle('hidden', !video.muted);
            muteButton.setAttribute('aria-pressed', String(video.muted));
            muteButton.setAttribute(
              'aria-label',
              video.muted ? muteButton.dataset.unmuteLabel : muteButton.dataset.muteLabel
            );
          };

          muteButton.addEventListener('click', (event) => {
            event.stopPropagation();
            video.muted = !video.muted;
            syncMuteState();
          });

          syncMuteState();
        }
      });

      const playActiveGalleryVideo = (swiper) => {
        if (!galleryInView || !swiper) return;
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide?.querySelector('video');
        activeVideo?.play().catch(() => {});
      };

      // LIPO-GALERIA: se parte siempre de pristineSlides para no arrastrar
      // los clones que el modo loop de Swiper agrega al wrapper.
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const pristineSlides = Array.from(wrapper.children);

      const buildSwiper = () => {
        if (gallerySwiper) {
          gallerySwiper.destroy(true, true);
          gallerySwiper = null;
        }
        gallerySwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: wrapper.children.length > 1,
          grabCursor: true,
          // el alto lo pone la foto activa: no hay caja fija que recorte ni
          // deje franjas cuando conviven verticales 2:3 y cuadradas
          autoHeight: true,
          // LIPO-NAV: se pasan los ELEMENTOS y no un selector de texto, porque
          // hay una galeria por seccion y un selector global agarraria la del
          // producto equivocado si hubiera mas de una en la pagina.
          navigation: {
            prevEl: swiperEl.querySelector('.lipo-nav-prev'),
            nextEl: swiperEl.querySelector('.lipo-nav-next'),
          },
          pagination: {
            el: swiperEl.querySelector('.lipo-dots'),
            clickable: true,
          },
          on: {
            realIndexChange: (swiper) => {
              setActiveThumb(swiper.realIndex);
              pauseGalleryVideos();
              playActiveGalleryVideo(swiper);
            },
          },
        });
      };

      applyGalleryColor = (color) => {
        // El valor que llega es el que ve la clienta, y en espanol dice "Negro".
        // Los alt de las fotos NO se traducen y siguen diciendo "Black", asi que
        // hay que pasar por el mapa que arma Liquid leyendo la foto destacada de
        // cada variante. Sin esto el filtro no encuentra nada y en espanol se
        // mezclan los dos colores.
        const crudo = String(color || '').toLowerCase().trim();
        const mapa = (productData && productData.colorMap) || {};
        const wanted = mapa[crudo] || crudo;
        // una media sin color (packshot, video) se muestra siempre
        let keep = pristineSlides.filter((el) => {
          const mc = String(el.dataset.mediaColor || '').toLowerCase();
          return !wanted || !mc || mc === wanted;
        });
        if (keep.length === 0) keep = pristineSlides.slice();

        const proximos = keep.map((el) => el.dataset.mediaId).join(',');
        const actuales = Array.from(wrapper.children).map((el) => el.dataset.mediaId).join(',');
        if (gallerySwiper && proximos === actuales) return;

        while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
        keep.forEach((el, i) => {
          el.dataset.index = String(i);
          el.style.display = '';   // el server las manda con display:none
          wrapper.appendChild(el);
        });

        const keepIds = keep.map((el) => el.dataset.mediaId);
        visibleThumbs = [];
        thumbs.forEach((thumb) => {
          const show = keepIds.indexOf(thumb.dataset.mediaId) !== -1;
          // no se usa el atributo `hidden`: la clase `flex` de Tailwind le gana
          // al display:none del stylesheet del navegador
          thumb.style.display = show ? '' : 'none';
          if (show) {
            thumb.dataset.index = String(visibleThumbs.length);
            visibleThumbs.push(thumb);
          }
        });

        buildSwiper();
      };

      buildSwiper();

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (gallerySwiper) gallerySwiper.slideToLoop(Number(thumb.dataset.index));
        });
      });

      if (galleryVideos.length > 0 && typeof IntersectionObserver !== 'undefined') {
        const galleryVisibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              galleryInView = entry.isIntersecting;
              if (galleryInView) {
                playActiveGalleryVideo(gallerySwiper);
              } else {
                pauseGalleryVideos();
              }
            });
          },
          { threshold: 0 }
        );

        galleryVisibilityObserver.observe(swiperEl);
      }
    }

    const sizeChartModal = root.querySelector('[data-size-chart-modal]');
    const sizeChartOverlay = sizeChartModal?.querySelector('[data-size-chart-overlay]');
    const sizeChartPanel = sizeChartModal?.querySelector('[data-size-chart-panel]');
    const sizeChartOpenButtons = Array.from(root.querySelectorAll('[data-size-chart-open]'));
    const sizeChartCloseButtons = sizeChartModal ? Array.from(sizeChartModal.querySelectorAll('[data-size-chart-close]')) : [];

    const setSizeChartOpen = (open) => {
      if (!sizeChartModal || !sizeChartOverlay || !sizeChartPanel) return;

      if (open) {
        sizeChartModal.classList.remove('hidden');
        sizeChartModal.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          sizeChartOverlay.classList.remove('opacity-0');
          sizeChartOverlay.classList.add('opacity-100');
          sizeChartPanel.classList.remove('scale-95', 'opacity-0');
          sizeChartPanel.classList.add('scale-100', 'opacity-100');
        });
        document.documentElement.classList.add('overflow-hidden');
      } else {
        sizeChartOverlay.classList.remove('opacity-100');
        sizeChartOverlay.classList.add('opacity-0');
        sizeChartPanel.classList.remove('scale-100', 'opacity-100');
        sizeChartPanel.classList.add('scale-95', 'opacity-0');
        sizeChartModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('overflow-hidden');
        window.setTimeout(() => {
          if (sizeChartModal.getAttribute('aria-hidden') === 'true') sizeChartModal.classList.add('hidden');
        }, 300);
      }
    };

    sizeChartOpenButtons.forEach((button) => button.addEventListener('click', () => setSizeChartOpen(true)));
    sizeChartCloseButtons.forEach((button) => button.addEventListener('click', () => setSizeChartOpen(false)));
    sizeChartOverlay?.addEventListener('click', () => setSizeChartOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sizeChartModal?.getAttribute('aria-hidden') === 'false') setSizeChartOpen(false);
    });

    const quantityInput = root.querySelector('[data-quantity-input]');
    const decreaseBtn = root.querySelector('[data-quantity-decrease]');
    const increaseBtn = root.querySelector('[data-quantity-increase]');

    const updateQuantityButtons = () => {
      if (!quantityInput || !decreaseBtn) return;
      decreaseBtn.disabled = Number(quantityInput.value) <= 1;
    };

    decreaseBtn?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value) - 1);
      updateQuantityButtons();
    });

    increaseBtn?.addEventListener('click', () => {
      quantityInput.value = Number(quantityInput.value) + 1;
      updateQuantityButtons();
    });

    quantityInput?.addEventListener('change', () => {
      if (Number(quantityInput.value) < 1) quantityInput.value = 1;
      updateQuantityButtons();
    });

    updateQuantityButtons();

    const optionInputs = Array.from(root.querySelectorAll('[data-option-value]'));
    const variantIdInput = root.querySelector('[data-selected-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareAtPriceEl = root.querySelector('[data-product-compare-price]');
    const saleBadgeEl = root.querySelector('[data-product-sale-badge]');
    const addButton = root.querySelector('[data-add-to-cart-button]');
    const addLabel = root.querySelector('[data-add-to-cart-label]');
    const addPrice = root.querySelector('[data-add-to-cart-price]');
    const productForm = addButton ? addButton.closest('form') : null;

    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;

      addButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm),
        });
        const data = await response.json();

        if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');

        document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: data.id } }));
      } catch (error) {
        productForm.submit();
        return;
      } finally {
        addButton.disabled = !getCurrentVariant()?.available;
      }
    });

    root.querySelectorAll('form.lipo-upsell-form').forEach((upsellForm) => {
      upsellForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const upsellButton = upsellForm.querySelector('button[type="submit"]');
        if (upsellButton && upsellButton.disabled) return;
        if (upsellButton) upsellButton.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(upsellForm),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: data.id } }));
        } catch (error) {
          upsellForm.submit();
          return;
        } finally {
          if (upsellButton) upsellButton.disabled = false;
        }
      });
    });

    const purchaseOptionsRoot = root.querySelector('[data-purchase-options]');
    const sellingPlanRadios = Array.from(root.querySelectorAll('[data-selling-plan-radio]'));
    const subscribeHeaderDot = root.querySelector('[data-subscribe-header-dot]');
    const subscribeComparePriceEl = root.querySelector('[data-subscribe-compare-price]');
    const subscribePriceEl = root.querySelector('[data-subscribe-price]');
    const subscribeBadgeEl = root.querySelector('[data-subscribe-badge]');
    const oneTimePriceEl = root.querySelector('[data-one-time-price]');
    const percentOffTemplate = purchaseOptionsRoot?.dataset.percentOffTemplate || '';
    const saveUpToTemplate = purchaseOptionsRoot?.dataset.saveUpToTemplate || '';

    /* LIPO: cuantos grupos de opciones hay. El arreglo de elegidas siempre
       tiene ese largo, con undefined en los grupos todavia sin marcar. */
    const totalOpciones = optionInputs.length
      ? Math.max(...optionInputs.map((input) => Number(input.dataset.optionIndex))) + 1
      : 0;

    const getSelectedOptions = () => {
      const selected = new Array(totalOpciones).fill(undefined);
      optionInputs.forEach((input) => {
        if (input.checked) selected[Number(input.dataset.optionIndex)] = input.dataset.optionValue;
      });
      return selected;
    };

    /* Un hueco es comodin. Sin esto, al no venir el talle preelegido, ningun
       valor seria igual a undefined y se tacharia el catalogo entero. */
    const coincide = (variant, elegidas) =>
      variant.options.every((valor, i) => elegidas[i] === undefined || valor === elegidas[i]);

    const getCurrentVariant = () => {
      if (optionInputs.length === 0) return productData.variants[0];
      const selected = getSelectedOptions();
      if (selected.some((valor) => valor === undefined)) return undefined;
      return productData.variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
    };

    const updateOptionAvailability = (selected) => {
      const ciColor = typeof productData.colorOptionIndex === 'number' ? productData.colorOptionIndex : -1;
      optionInputs.forEach((input) => {
        const index = Number(input.dataset.optionIndex);
        /* Cascada. El color se evalua libre -se tacha solo si ese color esta
           agotado entero- y el resto contra el color elegido. Si cada opcion
           se evaluara contra todas las demas, elegir un talle agotado tacharia
           los dos colores de una y la ficha quedaba sin salida. */
        const trial = new Array(totalOpciones).fill(undefined);
        if (ciColor >= 0 && index !== ciColor) trial[ciColor] = selected[ciColor];
        trial[index] = input.dataset.optionValue;
        /* con stock, no solo "la combinacion existe" */
        const hayStock = productData.variants.some((variant) => variant.available && coincide(variant, trial));
        const wrapper = input.nextElementSibling;
        if (wrapper) wrapper.classList.toggle('lipo-opt-off', !hayStock);
      });
    };

    const syncPurchasePricing = (variant) => {
      if (!variant || sellingPlanRadios.length === 0) return;

      const checkedRadio = sellingPlanRadios.find((radio) => radio.checked);
      const planId = checkedRadio ? checkedRadio.value : '';
      const isSubscribing = planId !== '';

      if (subscribeHeaderDot) subscribeHeaderDot.hidden = !isSubscribing;
      if (oneTimePriceEl) oneTimePriceEl.innerHTML = variant.priceHtml;

      let maxPercentOff = 0;
      sellingPlanRadios.forEach((radio) => {
        if (radio.value === '') return;
        const allocation = variant.sellingPlanAllocations[radio.value];
        const percentEl = root.querySelector('[data-selling-plan-percent="' + radio.value + '"]');
        if (allocation) {
          if (percentEl && percentOffTemplate) percentEl.textContent = percentOffTemplate.replace('__PERCENT__', allocation.percentOff);
          maxPercentOff = Math.max(maxPercentOff, allocation.percentOff);
        }
      });

      if (subscribeBadgeEl) {
        subscribeBadgeEl.hidden = maxPercentOff <= 0;
        if (maxPercentOff > 0 && saveUpToTemplate) {
          subscribeBadgeEl.textContent = saveUpToTemplate.replace('__PERCENT__', maxPercentOff);
        }
      }

      const activeAllocation = isSubscribing ? variant.sellingPlanAllocations[planId] : null;
      const subscribePriceHtml = activeAllocation ? activeAllocation.priceHtml : variant.priceHtml;

      if (subscribePriceEl) subscribePriceEl.innerHTML = subscribePriceHtml;
      if (subscribeComparePriceEl) subscribeComparePriceEl.innerHTML = variant.priceHtml;

      const activePriceHtml = activeAllocation ? activeAllocation.priceHtml : variant.priceHtml;
      if (priceEl) priceEl.innerHTML = activePriceHtml;
      if (addPrice) addPrice.innerHTML = activePriceHtml;
    };

    const updateVariant = () => {
      const selected = getSelectedOptions();
      updateOptionAvailability(selected);

      /* Sube aca arriba: sin talle elegido no hay variante y el return de mas
         abajo dejaba la galeria sin filtrar al cambiar de color. */
      if (applyGalleryColor) {
        const lipoCi = productData.colorOptionIndex;
        applyGalleryColor(typeof lipoCi === 'number' && lipoCi >= 0 ? selected[lipoCi] || '' : '');
      }

      const faltaElegir = selected.some((valor) => valor === undefined);
      const variant = faltaElegir
        ? undefined
        : productData.variants.find((candidate) =>
            candidate.options.every((value, index) => value === selected[index])
          );

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.toggleAttribute('data-elegir-talle', faltaElegir);
        }
        if (addLabel) {
          addLabel.textContent = faltaElegir
            ? addLabel.dataset.chooseSizeLabel || addLabel.dataset.unavailableLabel
            : addLabel.dataset.unavailableLabel;
        }
        if (addPrice) addPrice.hidden = true;
        if (compareAtPriceEl) compareAtPriceEl.hidden = true;
        if (saleBadgeEl) saleBadgeEl.hidden = true;
        return;
      }

      if (addButton) addButton.removeAttribute('data-elegir-talle');
      if (variantIdInput) variantIdInput.value = variant.id;

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available ? addLabel.dataset.availableLabel : addLabel.dataset.soldOutLabel;
      }
      if (addPrice) addPrice.hidden = !variant.available;

      if (compareAtPriceEl) {
        compareAtPriceEl.hidden = !variant.onSale;
        if (variant.onSale) compareAtPriceEl.innerHTML = variant.compareAtPriceHtml;
      }
      if (saleBadgeEl) {
        saleBadgeEl.hidden = !variant.onSale;
        if (variant.onSale) saleBadgeEl.textContent = variant.percentOffLabel;
      }

      if (sellingPlanRadios.length > 0) {
        syncPurchasePricing(variant);
      } else {
        if (priceEl) priceEl.innerHTML = variant.priceHtml;
        if (addPrice) addPrice.innerHTML = variant.priceHtml;
      }

      if (variant.featuredMediaId && gallerySwiper) {
        const slide = root.querySelector('[data-media-id="' + variant.featuredMediaId + '"]');
        if (slide) gallerySwiper.slideToLoop(Number(slide.dataset.index));
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    sellingPlanRadios.forEach((radio) => {
      radio.addEventListener('change', () => syncPurchasePricing(getCurrentVariant()));
    });

    const subscribeCard = root.querySelector('[data-subscribe-card]');
    const firstSellingPlanRadio = sellingPlanRadios.find((radio) => radio.value !== '');

    subscribeCard?.addEventListener('click', (event) => {
      if (event.target.closest('[data-selling-plan-radio]') || event.target.closest('label')) return;
      if (!firstSellingPlanRadio || firstSellingPlanRadio.checked) return;

      firstSellingPlanRadio.checked = true;
      firstSellingPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (optionInputs.length > 0) {
      updateVariant();
    } else if (sellingPlanRadios.length > 0) {
      syncPurchasePricing(getCurrentVariant());
    }
  }

  function initAllProductSections() {
    document.querySelectorAll('[data-product-section]').forEach(initProductSection);
  }

  window.addEventListener('load', initAllProductSections);
  document.addEventListener('shopify:section:load', initAllProductSections);

  /* LIPO-ZOOM */
  function initLipoZoom() {
    const overlay = document.querySelector('[data-lipo-zoom]');
    if (!overlay || overlay.dataset.listo === 'true') return;
    overlay.dataset.listo = 'true';

    const img = overlay.querySelector('[data-lipo-zoom-img]');
    let escala = 1, px = 0, py = 0, indice = 0, fuentes = [];
    let arrastrando = false, ox = 0, oy = 0;

    const aplicar = () => {
      img.style.transform = 'translate(' + px + 'px,' + py + 'px) scale(' + escala + ')';
      overlay.classList.toggle('is-zoomed', escala > 1.02);
    };
    const encuadrar = () => { escala = 1; px = 0; py = 0; aplicar(); };

    // Las grandes que ya se pidieron alguna vez. Image() queda referenciada
    // para que el navegador no descarte la descarga a mitad de camino.
    const precargadas = new Map();
    const precargar = (src) => {
      if (!src || precargadas.has(src)) return precargadas.get(src);
      const im = new Image();
      im.decoding = 'async';
      im.src = src;
      precargadas.set(src, im);
      return im;
    };

    const mostrar = (i) => {
      if (!fuentes.length) return;
      indice = (i + fuentes.length) % fuentes.length;
      const f = fuentes[indice];
      img.alt = f.alt;

      // 1. lo que ya esta en el cache, para que aparezca algo en cero
      const grande = precargar(f.src);
      if (grande.complete && grande.naturalWidth) {
        img.src = f.src;
      } else {
        if (f.previa) img.src = f.previa;
        const esperado = indice;
        grande.decode ? grande.decode().then(() => {
          if (indice === esperado && !overlay.hidden) img.src = f.src;
        }).catch(() => {}) : grande.addEventListener('load', () => {
          if (indice === esperado && !overlay.hidden) img.src = f.src;
        }, { once: true });
      }

      // 2. las vecinas, para que las flechas no esperen
      precargar(fuentes[(indice + 1) % fuentes.length].src);
      precargar(fuentes[(indice - 1 + fuentes.length) % fuentes.length].src);

      encuadrar();
    };

    const juntarFuentes = (boton) => {
      // el swiper en loop clona las slides: se deduplica por src, si no la
      // misma foto aparece dos veces al pasar de una a otra
      const vistos = new Set();
      fuentes = [];
      document.querySelectorAll('.lipo-zoom-open').forEach((b) => {
        const src = b.dataset.zoomSrc;
        if (!src || vistos.has(src)) return;
        if (b.closest('[style*="display:none"]')) return;   // color no elegido
        vistos.add(src);
        // la chica que la galeria ya bajo: sirve de primer cuadro instantaneo
        const mini = b.querySelector('img');
        fuentes.push({
          src: src,
          previa: mini && (mini.currentSrc || mini.src) || '',
          alt: b.dataset.zoomAlt || '',
        });
      });
      return fuentes.findIndex((f) => f.src === boton.dataset.zoomSrc);
    };

    const cerrar = () => {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
    };

    const abrir = (b) => {
      const i = juntarFuentes(b);
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      mostrar(i < 0 ? 0 : i);
    };

    // En desktop alcanza con el click. En mobile NO: el Swiper de la galeria
    // captura el gesto y el click nunca llega al boton, por eso el zoom no
    // andaba en el telefono. Se detecta el toque a mano: si el dedo se movio
    // menos de 10px es un tap, y si se movio mas es el usuario pasando de foto.
    let tx = 0, ty = 0, tocando = false;
    document.addEventListener('pointerdown', (e) => {
      const b = e.target.closest('.lipo-zoom-open');
      if (!b) return;
      tx = e.clientX; ty = e.clientY; tocando = true;
      // el dedo toco pero todavia no solto: 100-300 ms de ventaja para bajarla
      if (b.dataset.zoomSrc) {
        const im = new Image();
        im.decoding = 'async';
        im.src = b.dataset.zoomSrc;
      }
    }, { passive: true });

    document.addEventListener('pointerup', (e) => {
      const b = e.target.closest('.lipo-zoom-open');
      if (!b || !tocando) return;
      tocando = false;
      if (Math.abs(e.clientX - tx) < 10 && Math.abs(e.clientY - ty) < 10) abrir(b);
    });

    document.addEventListener('pointercancel', () => { tocando = false; });

    document.addEventListener('click', (e) => {
      // el pointerup ya lo abrio; esto solo evita que el boton haga submit
      if (e.target.closest('.lipo-zoom-open')) e.preventDefault();
    });

    overlay.querySelector('[data-lipo-zoom-close]').addEventListener('click', cerrar);
    overlay.querySelector('[data-lipo-zoom-prev]').addEventListener('click', (e) => {
      e.stopPropagation(); mostrar(indice - 1);
    });
    overlay.querySelector('[data-lipo-zoom-next]').addEventListener('click', (e) => {
      e.stopPropagation(); mostrar(indice + 1);
    });
    overlay.addEventListener('click', (e) => { if (e.target === overlay) cerrar(); });

    document.addEventListener('keydown', (e) => {
      if (overlay.hidden) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowLeft') mostrar(indice - 1);
      if (e.key === 'ArrowRight') mostrar(indice + 1);
    });

    img.addEventListener('click', (e) => {
      e.stopPropagation();
      if (escala > 1.02) { encuadrar(); return; }
      const r = img.getBoundingClientRect();
      escala = 2.5;
      px = (r.left + r.width / 2 - e.clientX) * (escala - 1);
      py = (r.top + r.height / 2 - e.clientY) * (escala - 1);
      aplicar();
    });

    overlay.addEventListener('wheel', (e) => {
      if (overlay.hidden) return;
      e.preventDefault();
      escala = Math.min(4, Math.max(1, escala - e.deltaY * 0.0025));
      if (escala <= 1) { px = 0; py = 0; }
      aplicar();
    }, { passive: false });

    img.addEventListener('pointerdown', (e) => {
      if (escala <= 1.02) return;
      arrastrando = true; ox = e.clientX - px; oy = e.clientY - py;
      img.setPointerCapture(e.pointerId);
    });
    img.addEventListener('pointermove', (e) => {
      if (!arrastrando) return;
      px = e.clientX - ox; py = e.clientY - oy; aplicar();
    });
    ['pointerup', 'pointercancel'].forEach((ev) => {
      img.addEventListener(ev, () => { arrastrando = false; });
    });
  }

  /* Cuando la galeria se queda quieta en una foto, se baja la version grande
     de ESA sola. Precargar las ocho serian 1.1 MB que capaz nadie mira. Va en
     requestIdleCallback para no pelear con lo que falte del primer render. */
  function precargarZoomVisible() {
    const enCola = new Set();
    const bajar = () => {
      document.querySelectorAll('.product-gallery-swiper .swiper-slide-active .lipo-zoom-open')
        .forEach((b) => {
          const src = b.dataset.zoomSrc;
          if (!src || enCola.has(src)) return;
          enCola.add(src);
          const im = new Image();
          im.decoding = 'async';
          im.src = src;
        });
    };
    const cuandoHaya = window.requestIdleCallback
      ? (fn) => window.requestIdleCallback(fn, { timeout: 2000 })
      : (fn) => setTimeout(fn, 600);
    cuandoHaya(bajar);
    document.querySelectorAll('.product-gallery-swiper').forEach((el) => {
      if (!el.swiper || el.dataset.zoomPrecarga === 'true') return;
      el.dataset.zoomPrecarga = 'true';
      el.swiper.on('slideChangeTransitionEnd', () => cuandoHaya(bajar));
    });
  }

  window.addEventListener('load', initLipoZoom);
  window.addEventListener('load', precargarZoomVisible);
  document.addEventListener('shopify:section:load', precargarZoomVisible);
  document.addEventListener('shopify:section:load', initLipoZoom);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-gallery"] && !Shopify.designMode) return;
  try {
    
  function initReviewsGallerySplide(root) {
    var splideEl = root.querySelector('[data-reviews-gallery-splide]');
    if (!splideEl || typeof Splide === 'undefined') return;
    if (splideEl.dataset.splideInitialized === 'true') return;
    splideEl.dataset.splideInitialized = 'true';

    var splide = new Splide(splideEl, {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      mobileFirst: true,
      autoplay: 'play',
      arrows: false,
      padding: { left: '100px', right: '100px' },
      pagination: false,
      gap: '6px',
      speed: 1000,
      breakpoints: {
        992: {
          centerMode: true,
          perPage: 1,
          padding: { left: '75px', right: '75px' },
          variableWidth: false,
          gap: '30px'
        }
      }
    });

    var progressContainer = root.querySelector('[data-reviews-gallery-progress]');
    var progressBar = root.querySelector('[data-reviews-gallery-progress-bar]');

    if (progressContainer && progressBar) {
      // Fixed-width thumb: it moves along the track as the real slides
      // progress, and snaps back to the start once the loop wraps around.
      splide.on('mounted move', function (newIndex) {
        var totalItems = splide.Components.Elements.slides.length;
        var index = typeof newIndex === 'number' ? newIndex : splide.index;
        progressBar.style.width = (100 / totalItems) + '%';
        progressBar.style.left = (index * (100 / totalItems)) + '%';
        progressBar.style.transition = 'left 500ms';
      });

      var scrubTo = function (event) {
        var totalItems = splide.Components.Elements.slides.length;
        var pointerX = event.clientX || (event.targetTouches && event.targetTouches[0].pageX);
        if (typeof pointerX !== 'number') return;
        var clickPercentage = ((pointerX - progressContainer.getBoundingClientRect().left) / progressContainer.clientWidth) * 100;
        var targetItem = Math.round((totalItems / 100) * clickPercentage) - 1;
        splide.go(targetItem);
      };

      var onPointerMove = function (event) { scrubTo(event); };
      var onPointerDown = function () {
        window.addEventListener('mousemove', onPointerMove, true);
        window.addEventListener('touchmove', onPointerMove, true);
      };
      var onPointerUp = function () {
        window.removeEventListener('mousemove', onPointerMove, true);
        window.removeEventListener('touchmove', onPointerMove, true);
      };

      progressContainer.addEventListener('click', scrubTo, true);
      progressContainer.addEventListener('mousedown', onPointerDown, true);
      progressContainer.addEventListener('touchstart', onPointerDown, true);
      window.addEventListener('mouseup', onPointerUp, true);
      window.addEventListener('touchend', onPointerUp, true);
    }

    splide.mount();
  }

  function initAllReviewsGallerySplides() {
    document.querySelectorAll('[data-reviews-gallery]').forEach(initReviewsGallerySplide);
  }

  function initReviewsGalleryVideoObserver(section) {
    if (typeof IntersectionObserver === 'undefined') return;
    if (section.dataset.videoObserverInitialized === 'true') return;
    section.dataset.videoObserverInitialized = 'true';

    var videos = section.querySelectorAll('.reviews-gallery-video');
    if (!videos.length) return;

    var splideEl = section.querySelector('[data-reviews-gallery-splide]');
    var track = splideEl && splideEl.querySelector('.splide__track');

    // Per-video, scoped to the carousel's own visible viewport (not the
    // whole page): only the clip(s) actually scrolled into view load their
    // real source and play. A small rootMargin starts the load a little
    // ahead of time so it's ready by the time it's fully in view. Videos
    // that scroll out get paused (not unloaded, so scrolling back doesn't
    // re-fetch) to avoid decoding clips nobody is looking at.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.dataset.videoSrc) {
              video.src = video.dataset.videoSrc;
              video.removeAttribute('data-video-src');
              video.load();
            }
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { root: track || null, rootMargin: '200px', threshold: 0.5 }
    );

    videos.forEach(function (video) { observer.observe(video); });
  }

  function initAllReviewsGalleryVideoObservers() {
    document.querySelectorAll('[data-reviews-gallery]').forEach(initReviewsGalleryVideoObserver);
  }

  window.addEventListener('load', function () {
    initAllReviewsGallerySplides();
    initAllReviewsGalleryVideoObservers();
  });
  document.addEventListener('shopify:section:load', function () {
    initAllReviewsGallerySplides();
    initAllReviewsGalleryVideoObservers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__searchModalLoaded) return;
    window.__searchModalLoaded = true;

    let controller = null;
    let debounceTimer = null;

    function getRoot() {
      return document.querySelector('[data-search-modal]');
    }

    function setOpen(open) {
      const root = getRoot();
      if (!root) return;
      const overlay = root.querySelector('[data-search-modal-overlay]');
      const panel = root.querySelector('[data-search-modal-panel]');

      if (open) {
        setExpanded(false);
        root.classList.remove('hidden');
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
          panel.classList.remove('-translate-y-full');
          panel.classList.add('translate-y-0');
        });
        document.documentElement.classList.add('overflow-hidden');
        const input = root.querySelector('[data-search-modal-input]');
        window.setTimeout(() => input && input.focus(), 300);
      } else {
        overlay.classList.remove('opacity-100');
        overlay.classList.add('opacity-0');
        panel.classList.remove('translate-y-0');
        panel.classList.add('-translate-y-full');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('overflow-hidden');
        window.setTimeout(() => {
          const current = getRoot();
          if (current && current.getAttribute('aria-hidden') === 'true') current.classList.add('hidden');
        }, 300);

        const input = root.querySelector('[data-search-modal-input]');
        if (input) input.value = '';
        clearResults();
      }
    }

    function setExpanded(expanded) {
      const root = getRoot();
      if (!root) return;
      const panel = root.querySelector('[data-search-modal-panel]');
      if (!panel) return;

      if (expanded) {
        panel.classList.remove('inset-x-0', 'top-0');
        panel.classList.add('inset-0', 'h-full', 'overflow-y-auto');
      } else {
        panel.classList.remove('inset-0', 'h-full', 'overflow-y-auto');
        panel.classList.add('inset-x-0', 'top-0');
      }
    }

    function clearResults() {
      const root = getRoot();
      if (!root) return;
      const results = root.querySelector('[data-search-results]');
      if (results) results.innerHTML = '';
      setExpanded(false);
    }

    function showLoading() {
      const root = getRoot();
      if (!root) return;
      const results = root.querySelector('[data-search-results]');
      if (!results) return;
      setExpanded(false);
      results.innerHTML =
        '<div class="flex w-full justify-center py-6"><div class="size-12 animate-spin rounded-full border-2 border-transparent border-l-[#070707]"></div></div>';
    }

    async function fetchResults(term) {
      const root = getRoot();
      if (!root) return;

      if (controller) controller.abort();
      controller = new AbortController();

      const sectionId = root.dataset.sectionId;
      const url = root.dataset.predictiveSearchUrl;
      if (!url) return;

      try {
        const response = await fetch(
          `${url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=${sectionId}`,
          { signal: controller.signal }
        );
        if (!response.ok) throw new Error(response.status);

        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-search-results]');
        const currentResults = root.querySelector('[data-search-results]');
        if (currentResults) currentResults.innerHTML = parsed ? parsed.innerHTML : '';
        setExpanded(!!currentResults?.querySelector('[data-search-has-results]'));
      } catch (error) {
        if (error.name === 'AbortError') return;
        clearResults();
      }
    }

    function bindEvents(root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      root.querySelector('[data-search-modal-overlay]')?.addEventListener('click', () => setOpen(false));
      root.querySelector('[data-search-modal-close]')?.addEventListener('click', () => setOpen(false));

      const input = root.querySelector('[data-search-modal-input]');
      input?.addEventListener('input', () => {
        const term = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (term === '') {
          if (controller) controller.abort();
          clearResults();
          return;
        }

        debounceTimer = window.setTimeout(() => {
          showLoading();
          fetchResults(term);
        }, 400);
      });
    }

    document.addEventListener('keydown', (event) => {
      const root = getRoot();
      if (event.key === 'Escape' && root && root.getAttribute('aria-hidden') === 'false') setOpen(false);
    });

    document.addEventListener('search:open', () => setOpen(true));

    function bindCurrentModal() {
      const current = getRoot();
      if (current) bindEvents(current);
    }

    window.addEventListener('load', bindCurrentModal);
    document.addEventListener('shopify:section:load', bindCurrentModal);
  })();

  } catch(e) { console.error(e); }
})();
})();
